const Kpi = ({ label, value, suffix="" }) => (
  <div className="rounded-lg bg-gray-50 border border-gray-200 px-3 py-2">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="mt-0.5 font-semibold text-gray-900">
      {value} <span className="text-xs font-normal text-gray-500">{suffix}</span>
    </div>
  </div>
)

export default Kpi